module.exports = __webpack_public_path__ + "img/Flag_of_Ireland.4a6b333e.svg";